export default {"src":"/_next/static/media/map.04da7834.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};